import {NgModule} from '@angular/core';
import {PanelsModule} from './panels/panels.module';
import {LogosModule} from './logos/logos.module';
import {ActionsModule} from './actions/actions.module';
import {IconsModule} from './icons/icons.module';
import {PipesModule} from './pipes/pipes.module';
import {FormModule} from './form/form.module';
import {ValidatorsModule} from './validators/validators.module';
import {FormService} from './form/form.service';
import {EntriesPipe} from './pipes/entries/entries.pipe';
import {KeyPipe} from './pipes/keys/key/key.pipe';
import {KeysPipe} from './pipes/keys/keys.pipe';
import {ValuePipe} from './pipes/values/value/value.pipe';
import {ValuesPipe} from './pipes/values/values.pipe';
import {StartsWithPipe} from './pipes/starts-with/starts-with.pipe';
import {ExcludesPipe} from './pipes/excludes/excludes.pipe';
import {IncludesPipe} from './pipes/includes/includes.pipe';
import {SortPipe} from './pipes/sort/sort.pipe';
import {WindowMessageService} from './window/window-message/window-message.service';
import {ButtonsModule} from './buttons/buttons.module';
import {DataModule} from './data/data.module';
import {TabsModule} from './tabs/tabs.module';
import {TextModule} from './text/text.module';
import {ModalsModule} from './modals/modals.module';
import {InjectionsModule} from './injections/injections.module';
import {InjectionsService} from './injections/injections.service';
import {InjectionService} from './injections/injection/injection.service';
import {RenderersModule} from './renderers/renderers.module';
import {StorageModule} from './storage/storage.module';
import {ExceptionsModule} from './exceptions/exceptions.module';

@NgModule({
    imports: [
        ActionsModule,
        ButtonsModule,
        DataModule,
        ExceptionsModule,
        FormModule,
        IconsModule,
        InjectionsModule,
        LogosModule,
        ModalsModule,
        PanelsModule,
        PipesModule,
        RenderersModule,
        StorageModule,
        TabsModule,
        TextModule,
        ValidatorsModule
    ],
    exports: [
        ActionsModule,
        ButtonsModule,
        DataModule,
        ExceptionsModule,
        FormModule,
        IconsModule,
        InjectionsModule,
        LogosModule,
        ModalsModule,
        PanelsModule,
        PipesModule,
        RenderersModule,
        StorageModule,
        TabsModule,
        TextModule,
        ValidatorsModule
    ],
    providers: [
        EntriesPipe,
        ExcludesPipe,
        FormService,
        IncludesPipe,
        InjectionService,
        InjectionsService,
        KeyPipe,
        KeysPipe,
        SortPipe,
        StartsWithPipe,
        ValuePipe,
        ValuesPipe,
        WindowMessageService
    ]
})
export class ViolaUIModule {
}
